var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'uupoop-root': !_vm.isOldVersion }},[_c('UupoopNav'),_c('router-view'),(!_vm.isOldVersion)?[_c('Footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }